import styles from './SectionHeader.module.scss'
import { SectionHeaderProps } from './types.ts'
import viewportHelper from '@content/helpers/src/viewport.helpers'

const SectionHeader = ({
    align = 'left',
    alignMobile = 'center',
    contrast = 'light',
    subhead = '',
    headline = '',
    description = '',
    small = false,
    className = '',
    ariaLabelledby = '',
    headlineTag: Tag = 'h3'
}: SectionHeaderProps) => {
    if (viewportHelper.is.mobile) {
        align = alignMobile
    }

    const alignClass = styles['heading__align--' + align]

    return (
        <div
            className={`${className} ${styles.heading} ${alignClass ? alignClass : ''} ${styles['heading__contrast--' + contrast]}`}>
            {subhead && <h4 className={styles.subhead}>{subhead}</h4>}
            {headline && (
                <Tag
                    className={
                        small ? styles['headline--small'] : styles.headline
                    }
                    aria-labelledby={ariaLabelledby}>
                    {headline}
                </Tag>
            )}
            {description && <p className={styles.description}>{description}</p>}
        </div>
    )
}

export default SectionHeader
